import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "helperText", "inputProps", "placeholder", "className"];
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "@i18n";
export function RHFTextField(_ref) {
  var name = _ref.name,
    helperText = _ref.helperText,
    inputProps = _ref.inputProps,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    className = _ref.className,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({}, field, {
        name: name,
        value: field.value,
        placeholder: placeholder,
        onChange: function onChange(e) {
          field.onChange(e);
          setIsFocused(true);
        },
        onClick: function onClick() {
          return setIsFocused(true);
        },
        onFocus: function onFocus() {
          return setIsFocused(true);
        },
        onBlur: function onBlur() {
          return setIsFocused(false);
        },
        autoFocus: other.autoFocus,
        disabled: other.disabled,
        className: className
      }, inputProps)), helperText && /*#__PURE__*/React.createElement("span", {
        className: ""
      }, helperText), error && /*#__PURE__*/React.createElement("span", {
        className: "errorText"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
}
export default RHFTextField;